<template>
  <div class="w-full">
    <div class="flex justify-center items-center w-full h-60px gap-4">
      <Button
        class="flex-1 h-full"
        scene="secondary"
        @click="emit('createCard')"
      >
        <div
          class="flex-1 flex items-center justify-center gap-10px text-ld-brand-500"
        >
          <Icon name="add_card" />
          {{ _t('package.create_card') }}
        </div>
      </Button>

      <Button
        class="flex-1 h-full"
        :disabled="props.aiButtonDisabled"
        @click="emit('aiGenerate')"
      >
        <div
          class="flex flex-col justify-center items-center gap-1 w-full whitespace-nowrap text-center font-600"
        >
          <div class="flex gap-1">
            <Icon
              name="ai-add-card"
              class="h-20px"
            />
            <div class="leading-20px">{{ _t('cardview.ai_gen_tip1') }}</div>
          </div>

          <div class="text-13px leading-[1.4]">
            {{
              props.aiButtonDisabled
                ? _t('cardview.ai_gen_tip2')
                : _t('cardview.ai_gen_tip3')
            }}
          </div>
        </div>
      </Button>
    </div>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps<{
  aiButtonDisabled: boolean
}>()

const emit = defineEmits<{
  createCard: []
  aiGenerate: []
}>()
</script>
<style scoped></style>
